import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import capitalize from 'lodash/capitalize'
import styles from './row.module.scss'

const Row = ({
  className,
  children,
  gutter,
  align,
  justify,
}) => {
  const variants = {
    base: '--row-gutter',
    sm: '--row-gutter-sm',
    md: '--row-gutter-md',
    lg: '--row-gutter-lg',
    xl: '--row-gutter-xl',
  }

  const gutterStyles = {}

  if( typeof gutter === 'object' && gutter !== null ) {
    Object.entries( variants ).forEach( ([ key, value ]) => {
      if( ! gutter.hasOwnProperty( key ) ) {
        return
      }

      gutterStyles[ value ] = gutter[ key ]
    })
  } else if( typeof gutter === 'string' ) {
    gutterStyles[ variants.base ] = gutter
  }

  return (
    <div
      className={ classNames(
        styles.row,
        align && styles[ `align${ capitalize( align ) }` ],
        justify && styles[ `justify${ capitalize( justify ) }` ],
        className
      )}
      style={ gutterStyles }
    >
      { children }
    </div>
  )
}

Row.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  gutter: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
  align: PropTypes.oneOf([ '', 'start', 'center', 'end', 'around', 'between', 'evenly', 'top' ]),
  justify: PropTypes.oneOf([ '', 'start', 'center', 'end', 'around', 'between', 'evenly' ]),
}

Row.defaultProps = {
  className: '',
  gutter: '',
  align: '',
  justify: '',
}

export default Row
